<template>
  <div class="login-container">
    <div class="form-section">
      <a-form @finish="onFinish" class="form">
        <span class="page-title">登入</span>
        <a-form-item :validateStatus="errors.username ? 'error' : ''" :help="errors.username" name="username">
          <a-label for="lastName" class="label">帳號</a-label>
          <a-input v-model:value="form.username" placeholder="請輸入您的帳號" class="input"/>
        </a-form-item>
        <a-form-item :validateStatus="errors.password ? 'error' : ''" :help="errors.password" name="password">
          <a-label for="lastName" class="label">密碼</a-label>
          <a-input-password v-model:value="form.password" placeholder="請輸入您的密碼" class="input"/>
        </a-form-item>
        <a-form-item>
          <a-button @click="onLoginButtonLicked" type="primary" html-type="submit" block class="btn-login">登入</a-button>
        </a-form-item>
        <router-link to="/forget-password" class="forgot-password">忘記密碼</router-link>
      </a-form>
      <span class="copyright">Copyright © 2024 彰化鍊水科技股份有限公司</span>
    </div>

    <div class="background-section">
      <div class="background-overlay"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginPage',
  inject: ['setUserData', 'setCompanyData', 'setSelectedCompany'],
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      errors: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    onFinish(values) {
      console.log('Form values:', values);
    },
    onLoginButtonLicked() {

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      this.$axios.post('/api/token/', {
        username: this.form.username,
        password: this.form.password
      }).then(response => {
        const token = response.data.access;
        localStorage.setItem('token', token);
        this.initialize(token);
      }).catch(error => {
        console.error(error);
        let errors = error.response.data
        for (let key in errors) {
          this.errors[key] = errors[key]['message']
        }
      });
    },
    initialize(token) {

      this.$axios.get('/api/users/profile', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        const profile = response.data.data;
        this.setUserData(profile);

        this.$axios.get('/api/organizations', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(response => {
          const companies = response.data.data;
          this.setCompanyData(companies);
          this.setSelectedCompany(companies[0])
          this.$router.push('/profile');

        }).catch(error => {
          console.error(error);
        });

      }).catch(error => {
        console.error(error);
      });
    }
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
}

.form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 100px;
  max-width: 500px;
  z-index: 10;
  background-color: #fff;
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
}

.form {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
}

.page-title {
  font-size: 48px;
  margin-bottom: 20px;
  text-align: center;
}

.label {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  margin-top: 12px;
}

.input {
  margin-top: 16px;
  padding: 12px;
  font-size: 18px;
  border-radius: 8px;
}

.btn-login {
  margin-top: 64px;
  height: auto;
  padding: 15px;
  border-radius: 16px;
  box-shadow: gray 0 3px 6px;
  font-size: 20px;
  font-weight: bold;
  background-color: #324ba6;
}

.forgot-password {
  display: block;
  margin-top: 35px;
  font-size: 20px;
  font-weight: bold;
  color: #324ba6;
  text-align: center;
}

.copyright {
  display: block;
  margin-bottom: 20px;
  text-align: center;
  font-size: 16px;
  color: #999999;
}

.background-section {
  flex: 2;
  background: url('~@/assets/background_login.webp') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -40px;
  width: 100%;
  height: 100vh;
}

.background-overlay {
  text-align: center;
  color: white;
}
</style>
